import {
  ReactEventHandler,
  type KeyboardEvent as ReactKeyboardEvent,
} from 'react';

import { safeGet } from '../../../core/utils/safe-get.js';
import { isSameDomain } from '../../../core/utils/zoom.js';
import type { AxisIdToScales } from '../../context/XYChartScales.context.js';
import type { XYChartAxisInternal } from '../../types/xy-chart-internals.js';
import { isZoomEnabledFor } from '../../utils/axis-interactions.js';

const allowWhenKeyIs =
  (key: ReactKeyboardEvent['key']) =>
  (action: (event?: ReactEventHandler) => void) =>
  (event: ReactKeyboardEvent) => {
    if (event.key === key) {
      action();
    }
  };

export const allowWhenKeyIsEnter = allowWhenKeyIs('Enter');

export function areAllDomainsUnchanged(
  axes: XYChartAxisInternal[],
  axisIdToScale: AxisIdToScales,
) {
  return axes.every((axis) => {
    if (isZoomEnabledFor(axis)) {
      const { currentScale, initialScale } = safeGet(axisIdToScale, axis.id);

      return isSameDomain(
        currentScale.domain() as (number | Date)[],
        initialScale.domain() as (number | Date)[],
      );
    }

    return true;
  });
}
